import React from 'react';
const VideoOutline = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="45" height="44" viewBox="0 0 45 44" fill="none" xmlns="http://www.w3.org/2000/svg"
        {...props}>
        <g clipPath="url(#clip0_1608_7124)">
            <path d="M42.6668 12.8333L29.8335 22L42.6668 31.1666V12.8333Z"
                stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M26.1668 9.16669H6.00016C3.97512 9.16669 2.3335 10.8083 2.3335 12.8334V31.1667C2.3335 33.1917 3.97512 34.8334 6.00016 34.8334H26.1668C28.1919 34.8334 29.8335 33.1917 29.8335 31.1667V12.8334C29.8335 10.8083 28.1919 9.16669 26.1668 9.16669Z"
                stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_1608_7124">
                <rect width="44" height="44" fill="white" transform="translate(0.5)" />
            </clipPath>
        </defs>
    </svg>

);

export default VideoOutline;